import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable()
export class DocumentStatusService {

  constructor(private http:HttpClient) { }

  public updateSeen(docId) {
    return this.http.post("/api/system/documentStatus/seen/" + docId,docId);
  }
}
